import { render, staticRenderFns } from "./shareInfo.vue?vue&type=template&id=68ee5916&scoped=true"
import script from "./shareInfo.vue?vue&type=script&lang=js"
export * from "./shareInfo.vue?vue&type=script&lang=js"
import style0 from "./shareInfo.vue?vue&type=style&index=0&id=68ee5916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee5916",
  null
  
)

export default component.exports